export const environment = {
    production: true,
    env: 'production',
    authUsername: "way-web-consumer",
    authPassword: "35413210-85ea-4c06-9204-94dc23ced73c",
    wayadmin: "https://wayplusndpp.way.com/way-admin/v1/",
    wayauth: "https://wayplusndpp.way.com/way-auth/",
    ndppwayauth: "https://wayplusndpp.way.com/way-auth/",
    wayndppadmin: "https://wayplusndpp.way.com/ndpp-admin/v1/",
    wayAdminConsumerUrl: 'https://wayplusndpp.way.com/way-consumer/',
    adminBaseUrl: 'https://wayplusndpp.way.com/',
    stripeKey: "pk_live_JauicenpYmJxOvXgM6EYQwC7",
    googleMapsApiKey: "AIzaSyBohv0Dgr8YJjvM--jSbjoB9RsUCfy3Sl4",
    radarPublishableKey: 'prj_test_pk_3b4e23843fb556b01ea21823e81d56068647bf28',
    radarCountryCode: 'US',
    radarMapStyle: '4c96cf07-af51-4e8f-85bd-86cfabfd9e79',
    s3ConfigUrl: 'https://way-images.s3.us-west-1.amazonaws.com/ui-config.json'
};
